import Header from "./components/header/header.tsx";
import Promo from "./components/main/promo.tsx";
import AboutUs from "./components/main/aboutUs.tsx";
import Footer from "./components/footer.tsx";
import Changes from "./components/main/changes.tsx"
import Prices from "./components/main/prices.tsx";
import Services from "./components/main/services.tsx";
import Faq from "./components/main/faq.tsx";
import Reviews from "./components/main/reviews.tsx";
import Location from "./components/main/location.tsx";

function App() {
  return (
    <div className="App">
      <Header />
      <Promo />
      <AboutUs />
      <Services />
      <Changes />
      <Prices />
      <Faq />
      <Reviews />
      <Location />
      <Footer />
    </div>
  );
}

export default App;
